import { memo, useMemo } from 'react'
import { useMatchBreakpoints, Pool } from '@pancakeswap/uikit'
import { usePool, useDeserializedPoolByVaultKey, useVaultPoolByKey } from 'state/pools/hooks'
import { DeserializedLockedVaultUser, Flexible2Locked, IsCakeVault, IsLocked, Locked2Flexible, VaultKey } from 'state/types'
import { getBalanceNumber } from '@pancakeswap/utils/formatBalance'
import { BIG_ZERO } from '@pancakeswap/utils/bigNumber'
import { findToken } from '@pancakeswap/tokens'
import { useActiveChainId } from 'hooks/useActiveChainId'

import NameCell from './Cells/NameCell'
import EarningsCell from './Cells/EarningsCell'
import AprCell from './Cells/AprCell'
import TotalStakedCell from './Cells/TotalStakedCell'
import EndsInCell from './Cells/EndsInCell'
import ActionPanel from './ActionPanel/ActionPanel'
import AutoEarningsCell from './Cells/AutoEarningsCell'
import AutoAprCell from './Cells/AutoAprCell'
import StakedCell from './Cells/StakedCell'

export const VaultPoolRow: React.FC<
  React.PropsWithChildren<{ vaultKey: VaultKey; account: string; initialActivity?: boolean }>
> = memo(({ vaultKey, account, initialActivity }) => {
  const { chainId } = useActiveChainId()
  const { isLg, isXl, isXxl } = useMatchBreakpoints()
  const isLargerScreen = isLg || isXl || isXxl
  const isXLargerScreen = isXl || isXxl
  const pool = useDeserializedPoolByVaultKey(vaultKey)
  pool.stakingToken = findToken(pool.stakingToken.symbol, chainId)
  pool.earningToken = findToken(pool.earningToken.symbol, chainId)
  const poolLocked = useDeserializedPoolByVaultKey(Flexible2Locked(vaultKey))
  
  // if(pool.vaultKey==VaultKey.NineInchFlexibleVault) console.log(pool, poolVault)
  const isCakeVault = IsCakeVault(vaultKey)
  
  const { stakingToken } = pool
  const { totalLockedAmount: totalLocked } = poolLocked as any
  // const { totalLockedAmount: totalLocked } = poolVault as DeserializedCakeVault
  const { totalCakeInVault, totalStakedAmount: totalStaked, userData } = useVaultPoolByKey(vaultKey)
  const poolFlexible = useVaultPoolByKey(Locked2Flexible(vaultKey))
  const isLockedVault = IsLocked(vaultKey) && (userData as DeserializedLockedVaultUser).locked
  const totalCakeInFlexibleVault = isCakeVault && isLockedVault ? poolFlexible.totalCakeInVault : BIG_ZERO

  const totalLockedAmount = isCakeVault ? totalCakeInVault.minus(totalCakeInFlexibleVault) : totalLocked // .minus(totalStaked ?? BIG_ZERO)
  const totalStakedAmount = isCakeVault ? totalCakeInVault : totalStaked
  // console.log(vaultKey, totalCakeInVault, totalStaked, poolVault)
  const totalStakedBalance = useMemo(() => {
    return getBalanceNumber(totalStakedAmount, stakingToken.decimals)
  }, [stakingToken.decimals, totalStakedAmount])
  const totalLockedBalance = useMemo(() => {
    return getBalanceNumber(totalLockedAmount, stakingToken.decimals)
  }, [stakingToken.decimals, totalLockedAmount])
  // const totalBalance = useMemo(() => {
  //   return getBalanceNumber(totalStaked, stakingToken.decimals)
  // }, [stakingToken.decimals, totalStaked])
  return (
    <Pool.ExpandRow initialActivity={initialActivity} panel={<ActionPanel account={account} pool={pool} expanded />}>
      <NameCell pool={pool} />
      {isXLargerScreen && <AutoEarningsCell pool={pool} account={account} />}
      {isXLargerScreen ? <StakedCell pool={pool} account={account} /> : null}
      {isXLargerScreen && <AutoAprCell pool={pool} />}
      {isLargerScreen && (
        <TotalStakedCell
          // locked={isLockedVault}
          stakingToken={stakingToken}
          totalStaked={isLockedVault ? totalLockedAmount : totalStakedAmount}
          totalStakedBalance={isLockedVault ? totalLockedBalance : totalStakedBalance}
        />
      )}
    </Pool.ExpandRow>
  )
})

const PoolRow: React.FC<React.PropsWithChildren<{ sousId: number; account: string; initialActivity?: boolean }>> = ({
  sousId,
  account,
  initialActivity,
}) => {
  const { chainId } = useActiveChainId()
  const { isLg, isXl, isXxl, isDesktop } = useMatchBreakpoints()
  const isLargerScreen = isLg || isXl || isXxl
  const { pool } = usePool(sousId)
  const { totalStaked } = pool
  const stakingToken = findToken(pool.stakingToken.symbol, chainId)
  const totalStakedBalance = useMemo(() => {
    return getBalanceNumber(totalStaked, stakingToken.decimals)
  }, [stakingToken.decimals, totalStaked])
  return (
    <Pool.ExpandRow initialActivity={initialActivity} panel={<ActionPanel account={account} pool={pool} expanded />}>
      <NameCell pool={pool} />
      <EarningsCell pool={pool} account={account} />
      {isLargerScreen && (
        <TotalStakedCell
          stakingToken={stakingToken}
          totalStaked={totalStaked}
          totalStakedBalance={totalStakedBalance}
        />
      )}
      <AprCell pool={pool} />
      {isDesktop && <EndsInCell pool={pool} />}
    </Pool.ExpandRow>
  )
}

export default memo(PoolRow)
